import { Component, Input } from '@angular/core';
import { ModalComponent } from '../modal.component';
import { ModalService } from '../../../../services/modal.service';

export interface ConfirmModalInput {
  heading?: string;
  content?: string;
  cancelButtonLabel?: string;
  saveButtonLabel?: string;
}

@Component({
  selector: 'app-confirm-modal',
  templateUrl: './confirm-modal.component.html',
  styleUrls: ['./confirm-modal.component.less'],
})
export class ConfirmModalComponent extends ModalComponent {
  @Input() heading = '';
  @Input() content = '';
  @Input() cancelButtonLabel = 'Translation.No';
  @Input() saveButtonLabel = 'Translation.Changemodalconfirmbtn';
  @Input() showOnlyOne: boolean = false;
  @Input() showWarning: boolean = true;

  constructor(public modalService: ModalService) {
    super(modalService);
  }

  cancelHandler(): void {
    this.cancel();
  }

  confirmHandler(): void {
    this.close(true);
  }
}
